import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'WC Home Remodeling | Quality Construction & Remodeling in Union NJ';
render(<App data-id="element-298" />, document.getElementById('root'));